export function getMonthName(date: Date) {
  return date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
}
